import { createFileRoute } from "@tanstack/react-router";
import Roofing from "@/pages/Roofing";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/roofing")({
  head: () =>
    seo({
      title: "Roofing Contractor in Minneapolis, MN",
      description:
        "GAF & Owens Corning certified roofing in the Twin Cities. Replacement, repair, and storm damage restoration built for Minnesota winters. Call (612) 298-9865.",
      path: "/roofing",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Roofing", path: "/roofing" },
      ]),
    }),
  component: Roofing,
});
